<template>
    <div class="w-full h-full flex flex-col gap-y-2">
        <button 
        type="button" 
        class="flex gap-x-1 cursor-pointer text-eblack-600" 
        @click="handleCloseModal()">
            <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"/>
            </svg>
            <span>{{ $t("settings.auto.cerrar") }}</span>
        </button>
        
        <div class="border-b border-eblack-300">
            <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-eblack-950 bg-eblack-100/70 rounded-t-md pt-0.5 px-0.5">
                <li class="me-2">
                    <button 
                    type="button" 
                    @click="tab = 1"
                    v-bind:class="[tab == 1 ? 'bg-white border-b border-eorange-300' : 'border-transparent']"
                    class="inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg hover:text-gray-600 hover:border-gray-300 group">
                        <svg 
                        class="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                            <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                        </svg>{{ $t("settings.auto.formulario") }}</button>
                </li>
            </ul>
        </div>

        <FormTab v-show="tab == 1" :pUser="userSelected" @close-modal="handleCloseModal" ref="formUserTab"/>
    </div>
</template>

<script>
import FormTab from './FormTab.vue';

export default {
    props:['user'],
    name:'FormLayout',
    data(){
        return {
            tab:1,
            userSelected:null
        }
    },
    watch:{
        'user':{
            handler(value){
                if(value){
                    this.userSelected = value
                }else{
                    this.userSelected = null
                }
            },
            immediate:true
        }
    },
    components:{
        FormTab
    },
    methods:{
        handleCloseModal(){
            this.userSelected = null
            this.$emit('close-modal')
            this.$emit('init-data')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
